import { NgFor, NgIf } from '@angular/common';
import { Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Departure, MapStation } from '../../core/models';
import { HttpService } from '../../core/services';
import { DetourComponent, LoadingComponent } from '../../shared/components';
import { TimeFormatPipe, TranslationPipe } from '../../shared/pipes';
import { LayerService } from '../map/services';

@Component({
  selector: 'app-departures',
  standalone: true,
  imports: [RouterLink, NgIf, NgFor, DetourComponent, TimeFormatPipe, TranslationPipe, LoadingComponent],
  templateUrl: './departures.component.html'
})
export class DeparturesComponent implements OnInit {
  private readonly noResultNotice: string = 'Žádné odjezdy v nejbližších dvou hodinách.';
  notice: string | undefined = undefined;
  exceptionDescription: string | undefined = undefined;
  stopId?: string;
  stop?: MapStation;
  departures: Departure[] = [];
  loading = false;

  constructor(
    private readonly ngZone: NgZone,
    private readonly route: ActivatedRoute,
    private readonly httpService: HttpService,
    private readonly layerService: LayerService) { }

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.notice = undefined;
      this.stopId = params.get('id') ?? '';
      if (this.stopId.length > 0) {
        this.departures = [];
        this.ngZone.run(() => {
          // mapa je mimo ngZonu, obnovime po prokliku z ní
          this.getDepartures(this.stopId!);
        });
        this.getStation(this.stopId);
      }
    });    
  }

  getName(departure: Departure) {
    switch (departure.vehicleType) {
      case 'V': // vlak
        return departure.name;
      case 'A': // MHD
        return departure.lineNumber;
      default:
        return departure.extLineName ?? `${departure.lineNumber?.toString()}/${departure.serviceNumber?.toString()}`;
    }
  }

  getDate(dateString: string): Date {
    return new Date(dateString);
  }

  openStreetview() {
    const agent = window.navigator.userAgent.toLowerCase()
    const isFirefox = agent.indexOf('firefox') > -1;
    if (this.stop)
      if (isFirefox)
        window.open(`https://www.google.com/maps?q&layer=c&cbll=${this.stop.lat},${this.stop.lon}&v=3.28`, '_blank');
      else
        window.open(`https://www.google.com/maps?q&layer=c&cbll=${this.stop.lat},${this.stop.lon}`, '_blank');
  }

  private async getDepartures(id: string) {
    this.loading = true;
    this.httpService.getDepartures(id).subscribe({
      next: result => {
        if (result.length == 0)
          this.notice = this.noResultNotice;
        else if (result[0].exceptionDescription)
          this.exceptionDescription = result[0].exceptionDescription;
        else
          this.departures = result;

        this.loading = false;
      }
    });
  }

  private async getStation(id: string) {
    this.httpService.getStation(id).subscribe({
      next: station => {
        this.stop = station;
        if (this.stop?.lat && this.stop.lat > 0)
          this.layerService.moveTo(this.stop.lat, this.stop.lon, 15)
      }
    });
  }
}
